import { TranslocoPipe } from '@jsverse/transloco';
import { Component, Input } from '@angular/core';
import { BaseWidgetComponent } from '../../../../../home/home-widgets/widgets/base-widget.component';
import { FuelConsumptionService } from '../../../services/fuel-consumption.service';
import { FilterService } from '../../../../../_shared/services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ErrorHandlerService } from '../../../../../_shared/services/error-handler.service';
import { AccountFilterData, DateIntervalFilterData, SummaryRequest } from '../../../../../_shared/models';
import { transformValue } from '../../../../../_shared/helpers/kpiWidget/kpi-formatters.helper';
import { KpiWidgetComponent } from '../../../../../_shared/components/kpi-widget/kpi-widget.component';

@Component({
  selector: 'app-total-trips-widget',
  standalone: true,
  imports: [TranslocoPipe, KpiWidgetComponent],
  templateUrl: './total-trips-widget.component.html',
  styleUrl: './total-trips-widget.component.scss'
})
export class TotalTripsWidgetComponent extends BaseWidgetComponent {
  @Input() dateFilter: DateIntervalFilterData;
  @Input() accountFilter: AccountFilterData;
  @Input() modalFilterHeaders: { previous: string; current: string };

  request: SummaryRequest;
  icon: string = 'assets/images-fuel/totalTripIconNew.svg';
  totalTripsPercentageChange: any;
  hasError: boolean = false;
  errorMessage: string = '';

  constructor(
    private fuelConsumptionService: FuelConsumptionService,
    protected override filterService: FilterService,
    private modalService: NgbModal,
    private errorHandlerService: ErrorHandlerService
  ) {
    super(filterService);
    this.title = 'Total Trips';
    this.isLoading = true;
    this.value = 0;
    this.difference = 0;
    this.widgetDisabled = true;
  }

  protected override async onFilterChangeAsync(): Promise<void> {
    await this.getTotalTripsKpiStats();
  }

  public override formatValue(value: number): string {
    return transformValue(value);
  }

  async getTotalTripsKpiStats() {
    this.isLoading = true;
    this.hasError = false;

    try {
      this.request = {
        accountIds: this.widgetFilter.accountIds,
        timeFrom: this.widgetFilter.startDate!,
        timeTo: this.widgetFilter.endDate!,
        previousTimeFrom: this.widgetFilter.previousCycleStartDate!,
        previousTimeTo: this.widgetFilter.previousCycleEndDate!,
      }

      this.cancelSubject.next();
      const response = await this.fuelConsumptionService.getTotalTripsKpiStats(this.request, this.cancelSubject);
      this.value = response.data?.totalValue ?? 0;
      this.totalTripsPercentageChange = response.data?.percentageChange;
      this.isLoading = false;
    } catch (error: any) {
      this.errorHandlerService.handleError(error, {
        callback: (message) => {
          this.errorMessage = message;
          this.hasError = true;
          this.isLoading = false;
        }
      });
    }
  }
}